export class BestellungPreisUndMwstSatz {
  Preis: number;
  Mehrwertsteuersatz: number;
}
